import { createAction, props } from "@ngrx/store";
import { PupilDuplicateGroup } from "@core/models/domain/pupil-duplicate.domain";

// LOAD
export const loadPupilDuplicates = createAction('[PupilDuplicate] Load Groups');
export const loadPupilDuplicatesSuccess = createAction(
  '[PupilDuplicate] Load Groups Success',
  props<{ groups: PupilDuplicateGroup[] }>()
);
export const loadPupilDuplicatesFailure = createAction(
  '[PupilDuplicate] Load Groups Failure',
  props<{ error: any }>()
);

// NOT THE SAME CHILD
export const dismissPupilDuplicate = createAction(
  '[PupilDuplicate] Dismiss Group',
  props<{ groupId: string }>()
);
export const dismissPupilDuplicateSuccess = createAction(
  '[PupilDuplicate] Dismiss Group Success',
  props<{ groupId: string }>()
);
export const dismissPupilDuplicateFailure = createAction(
  '[PupilDuplicate] Dismiss Group Failure',
  props<{ groupId: string; error: any }>()
);

// REMOVE COPIES: takes the chosen pupils off the school (the existing remove-user endpoint).
export const removePupilDuplicateMembers = createAction(
  '[PupilDuplicate] Remove Members',
  props<{ groupId: string; accountIds: string[] }>()
);
export const removePupilDuplicateMembersSuccess = createAction(
  '[PupilDuplicate] Remove Members Success',
  props<{ groupId: string; accountIds: string[] }>()
);
export const removePupilDuplicateMembersFailure = createAction(
  '[PupilDuplicate] Remove Members Failure',
  props<{ groupId: string; error: any }>()
);
